if (!customElements.get('product-carousel-element')) {
  class ProductCarouselElement extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this._observer = null;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      if (!this.buildUrl()) {
        this.hideSection();
        return;
      }

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.fetchProducts();
              this._observer.unobserve(this);
              this._observer = null;
            }
          });
        }, { rootMargin: '200px' });
        this._observer.observe(this);
      } else {
        this.fetchProducts();
      }
    }

    disconnectedCallback() {
      this._observer?.disconnect();
      this._observer = null;
    }

    get sectionSelector() {
      return '';
    }

    buildUrl() {
      return this.dataset.url || null;
    }

    async fetchProducts() {
      const url = this.buildUrl();
      if (!url) {
        this.hideSection();
        return;
      }

      try {
        const html = await theme.cache.request(url);
        const doc = theme.utils.domParser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector(this.tagName.toLowerCase());

        if (newContent && newContent.innerHTML.trim()) {
          this.innerHTML = newContent.innerHTML;
          this.initializeSlider();
          this.showSection();
        } else {
          this.hideSection();
        }
      } catch {
        this.hideSection();
      }
    }

    initializeSlider() {
      const slider = this.querySelector('theme-slider');
      if (slider && typeof slider.setUpSlider === 'function') {
        slider.initObserver?.disconnect();
        slider.initObserver = null;
        slider.setUpSlider();
      }
    }

    hideSection() {
      this.removeAttribute('aria-busy');
      this.innerHTML = '';
      const section = this.closest(this.sectionSelector);
      if (section) section.style.display = 'none';
    }

    showSection() {
      this.removeAttribute('aria-busy');
      const section = this.closest(this.sectionSelector);
      if (section) section.style.display = '';
    }
  }

  customElements.define('product-carousel-element', ProductCarouselElement);
}
